
export const allSongs=[
    {
        song:'Closer',
        src:'../music/Closer (feat. Amanda Lindsey Cook).mp3',
        artist:'Amanda Lindsey Cook',
        time:'2:40',
        id:1,
        originalId:1
    },
    {
        song:'African Praise',
        src:'../music/African Praise(01)-1.mp3',
        artist:'Gabriel Eziashi',
        time:'14:00',
        id:2,
        originalId:2
    },
    {
        src:'../music/What A Beautiful Name LIVE in Israel - Hillsong UNITED.mp3',
        song:'What A Beautiful Name',
        artist:'Hillsong UNITED',
        time:'5:38',
        id:3,
        originalId:3
    },
    {
        song:'Reckless Love',
        src:'../music/Michael W. Smith - Reckless Love (Live Concert Video).mp3',
        artist:'Michael W. Smith',
        time:'5:39',
        id:4,
        originalId:4
    },
    {
        song:'Alpha and Omega',
        src:'../music/Alpha and Omega - Israel and New Breed (with) (Best Heavenly Worship Song).mp3',
        artist:'isreal and new breed',
        time:'8:14',
        id:5,
        originalId:5
    },
    {
        song:'Firm Foundation',
        src:'../music/Firm Foundation (He Won’t) [feat. Chandler Moore & Cody Carnes] Maverick City Music TRIBL.mp3',
        artist:'Maverick City',
        time:'8:39',
        id:6,
        originalId:6
    },
    {
        src:'../music/Chris Tomlin - How Great Is Our God (Live In Nashville 2022) ft. Hillsong UNITED.mp3',
        song:'How Great Is Our God',
        artist:'Chris Tomlin',
        time:'5:45',
        id:7,
        originalId:7
    },
    {
        src:'../music/Draw Me Close feat. Michael Bethany Gateway Worship.mp3',
        song:'Draw Me Close',
        artist:'Michael Bethany',
        time:'2:40',
        id:8,
        originalId:8
    },
    {
        src:'../music/Esther Orji (Coza Worship)- Eh Eh Eh Ah Ah - Long Version.mp3',
        song:'Eh Eh Eh Ah Ah',
        artist:'Esther Orji',
        time:'6:38',
        id:9,
        originalId:9
    },
    {
        src:'../music/I See the Lord (Live) - Ron Kenoly_SLKeOAo2sX0.mp3',
        song:'I See the Lord',
        artist:'Ron Kenoly',
        time:'9:27',
        id:10,
        originalId:10
    },
    {
        src:'../music/Joy is Coming (feat. Travis Greene) Todd Galberth.mp3',
        song:'Joy is Coming',
        artist:'Todd Galberth ft Travis Greene',
        time:'6:13',
        id:11,
        originalId:11
    },
    { 
        src:'../music/Michael W. Smith - Agnus Dei.mp3',
        song:'Angnus Dei',
        artist:'Michael W. Smith',
        time:'10:15',
        id:12,
        originalId:12
    },
    {
        src:'../music/Paul-Wilbur-I-Enter-The-Holy-Of-Holies.mp3',
        song:'I Enter The Holy Of Holies',
        artist:'Paul-Wilbur',
        time:'5:23',
        id:13,
        originalId:13
    },
    {
        src:'../music/Phil Wickham - Living Hope (Official Music Video).mp3',
        song:'Living Hope',
        artist:'Phil Wickham',
        time:'5:31',
        id:14,
        originalId:14
    },
    {
        src:'../music/Sammie okposo Sing Halleluyah {Live}.mp3',
        song:'Sing Halleluyah',
        artist:'Sammie okposo',
        time:'3:12',
        id:15,
        originalId:15
    },
    {
        src:'../music/The Lord s Prayer - Hillsong Worship.mp3',
        song:'The Lords Prayer',
        artist:'Hillsong Worship',
        time:'5:56',
        id:16,
        originalId:16
    },
    {
        src:'../music/Who You Say I Am - Hillsong Worship.mp3',
        song:'Who You Say I Am',
        artist:'Hillsong Worship',
        time:'5:29',
        id:17,
        originalId:17
    },
    {
        src:'../music/Worship Your Maker - Dunsin Oyekan.mp3',
        song:'Worship Your Maker',
        artist:'Dunsin Oyekan',
        time:'7:54',
        id:18,
        originalId:18
    },
    {
        src:'../music/Worthy Is The Lamb - Hillsong Worship.mp3',
        song:'Worthy Is The Lamb',
        artist:'Hillsong Worship',
        time:'6:14',
        id:19,
        originalId:19
    },
    {
        song:'Healing Rain Majesty',
        src:'../music/Healing Rain Majesty Michael W Smith.mp3',
        artist:'Michael W Smith',
        time:'6:25',
        id:20,
        originalId:20
    },
]



